import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}
export function CTAButton({
  children,
  href = '#oferta',
  className = '',
  onClick
}: CTAButtonProps) {
  return <motion.a href={href} onClick={onClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`inline-block bg-teal-dark text-white font-semibold text-center px-8 py-4 rounded-full shadow-lg hover:shadow-glow transition-shadow duration-300 ${className}`} data-id="element-169">
      {children}
    </motion.a>;
}